export default  {
    REPORT_TYPES: {
        REPORT : 'report',
        DASBOARD: 'dashboard'
    },
    PRE_PAID_LUMP_SUM : "Pre-paid Lump Sum",
    ANNUALLY: "Annually"
}